/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import PropTypes from 'prop-types'
import UIkit from 'uikit'
import moment from 'moment'
import { withRouter } from 'react-router-dom'

// Components
import CodeEditor from 'app/views/components/CodeEditor'
import Icon from 'app/views/components/Icon'
import CodeOutput from 'app/views/components/CodeOutput'
import PatchHistory from 'app/views/components/PatchHistory'
import ProxyEditor from 'app/views/components/ProxyEditor'
import ProxyHistory from 'app/views/components/ProxyHistory'
import Notification from 'app/views/components/Notification'

// Utils
import analytics from 'app/views/utils/analytics'
import getLocalDateFromUTC from 'app/views/utils/getLocalDateFromUTC'

const propTypes = {
  hideCodeButton: PropTypes.bool,
  requestCount: PropTypes.number.isRequired,
  requests: PropTypes.arrayOf(PropTypes.object).isRequired,
  pendingRequest: PropTypes.object,
  engines: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClickResume: PropTypes.func.isRequired,
  onReplOnViewError: PropTypes.func.isRequired,
  socket: PropTypes.object,
  onReplSetDefaultEngine: PropTypes.func.isRequired,
}
const defaultProps = {
  hideCodeButton: false,
}


class LessonSidebar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      editorIsVisible: false,
      viewedPatches: false,
      viewedCodeOutput: false,
      output: '',
      codeSubmissionMoreThan5min: false,
    }
    this.handleClickProxy = this.handleClickProxy.bind(this)
    this.handleClickProxyTab = this.handleClickProxyTab.bind(this)
    this.handleClickHistory = this.handleClickHistory.bind(this)
    this.handleClickHistoryTab = this.handleClickHistoryTab.bind(this)
    this.handleClickCode = this.handleClickCode.bind(this)
    this.handleClickCodeOutput = this.handleClickCodeOutput.bind(this)
    this.handleClickPatches = this.handleClickPatches.bind(this)
    this.handleClickCodeTab = this.handleClickCodeTab.bind(this)
    this.handleClickCodeOutputTab = this.handleClickCodeOutputTab.bind(this)
    this.handleClickPatchHistoryTab = this.handleClickPatchHistoryTab.bind(this)
    this.handleOnPatch = this.handleOnPatch.bind(this)
    this.handleReplSetEngine = this.handleReplSetEngine.bind(this)
    this.jigglePatch = this.jigglePatch.bind(this)
    this.jiggleCodeOutput = this.jiggleCodeOutput.bind(this)
    this.checkedFirstTime = false
  }

  componentDidMount() {
    UIkit.util.on('#offcanvas-proxy', 'hide', () => {
      document.getElementsByTagName('body')[0].scrollTop = 0
      this.setState({ editorIsVisible: false })
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const buttonPatch = document.getElementById('proxy-patches-button')
    const outputPatch = document.getElementById('proxy-code-output-button')

    if (buttonPatch !== null && outputPatch !== null) {
      if (nextProps.output !== this.props.output) {
        this.setState({ output: nextProps.output })

        if (nextProps.output === '') {
          outputPatch.classList.add('uk-background-secondary')
          outputPatch.classList.remove('uk-button-danger')
        }
      }

      if (nextProps.codeSubmissions.length > 0) {
        if (this.props.codeSubmissions.length < nextProps.codeSubmissions.length) {
          this.checkedFirstTime = false
        }
        if (
          !this.checkedFirstTime
          && nextProps.codeSubmissions
          && nextProps.codeSubmissions.length > 0
        ) {
          this.checkedFirstTime = true
          this.setState({
            codeSubmissionMoreThan5min: (getLocalDateFromUTC(nextProps.codeSubmissions[0].submitted_at)).isAfter(moment().subtract(5, 'minutes')),
          }, () => {
            if (!this.state.codeSubmissionMoreThan5min && nextProps.codeSubmissions[0].test.passed === null && this.props.hasTest) {
              UIkit.notification({
                message: '<div class="uk-text-small"><span data-test-id="test-failed-notification" class="ri-error-warning-line"></span> This test is taking longer than expected, so something may have gone wrong. Please try to re-submit your code to have it re-graded.</div>',
                status: 'danger',
                pos: 'top-right',
                timeout: 15000,
              })
            }
          })
        }
        if (nextProps.output !== this.props.output) {
          this.setState({ viewedCodeOutput: false, output: nextProps.output }, () => {
            if (nextProps.output !== '' && nextProps.output !== null) {
              this.jiggleCodeOutput()
            } else {
              outputPatch.classList.add('uk-background-secondary')
              outputPatch.classList.remove('uk-button-danger')
            }
          })
        }

        if (nextProps.hasTest) {
          if (
            nextProps.codeSubmissions.length > this.props.codeSubmissions.length
            && nextProps.codeSubmissions[0].test.passed === null
            && this.props.hasTest
          ) {
            // new test just started running
            const engine = this.codeEditorComponent.getEngine()
            UIkit.notification(renderToStaticMarkup(
              <Notification
                lessonId={this.props.match.params.id}
                engine={engine}
                patchingTimes={this.props.patchingTimes || {}}
              />,
            ), {
              pos: 'top-right',
              timeout: 10000,
            })
          } else if (nextProps.codeSubmissions[0].test.passed === false) {
            buttonPatch.classList.add('uk-button-danger')
            buttonPatch.classList.remove('uk-background-secondary')
          } else if (nextProps.codeSubmissions[0].test.passed === true) {
            buttonPatch.classList.add('uk-background-secondary')
            buttonPatch.classList.remove('uk-button-danger')
          }

          if (
            this.props.codeSubmissions.length > 0
            && this.props.codeSubmissions[0].test.passed === null
            && nextProps.codeSubmissions[0].test.passed === false
            && this.props.hasTest
          ) {
            UIkit.notification({
              message: '<span data-test-id="test-failed-notification" class="ri-error-warning-line"></span> Test Failed!<br /><div class="uk-text-small">Click "TESTS" below to see why.</div>',
              status: 'danger',
              pos: 'top-right',
            })
            this.setState({ viewedPatches: false }, () => {
              this.jigglePatch()
            })
          } else if (
            this.props.codeSubmissions.length > 0
            && this.props.codeSubmissions[0].test.passed === null
            && nextProps.codeSubmissions[0].test.passed === true
            && this.props.hasTest
          ) {
            UIkit.notification({
              message: '<span data-test-id="text-passed-notification" className="ri-check-line"></span> Test Passed!',
              status: 'success',
              pos: 'top-right',
            })
          }
        }
      }
    }
  }

  componentDidCatch(e) {
    UIkit.notification({
      message: 'Error loading proxy tools. Please try clicking \'Reset Sandbox\'.',
      status: 'danger',
      pos: 'bottom-center',
    })
  }

  componentWillUnmount() {
    if (this.timeoutForRepull) {
      clearTimeout(this.timeoutForRepull)
    }
  }

  jigglePatch() {
    const button = document.getElementById('proxy-patches-button')
    if (button !== null) {
      button.classList.add('uk-animation-shake')
      setTimeout(() => {
        button.classList.remove('uk-animation-shake')
      }, 500)
      if (this.state.viewedPatches === false) {
        setTimeout(() => {
          // this.jigglePatch()
        }, 2000)
      }
    }
  }

  jiggleCodeOutput() {
    const button = document.getElementById('proxy-code-output-button')
    if (button !== null) {
      if (this.state.output !== '') {
        button.classList.add('uk-animation-shake')
        setTimeout(() => {
          button.classList.remove('uk-animation-shake')
        }, 500)
        if (this.state.viewedCodeOutput === false && this.state.output !== '') {
          setTimeout(() => {
            this.jiggleCodeOutput()
          }, 2000)
        }
      } else {
        button.classList.remove('uk-button-danger')
        button.classList.add('uk-background-secondary')
      }
    }
  }

  handleClickProxy() {
    analytics.track('click-sidebar-proxy', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      position: 'sidebar',
    })

    UIkit.offcanvas('#offcanvas-proxy').show()
    UIkit.tab('#tab-proxy').show(0)
  }

  handleClickProxyTab() {
    analytics.track('click-sidebar-proxy', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      position: 'tab',
    })
  }

  handleClickHistory() {
    analytics.track('click-sidebar-history', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      position: 'sidebar',
    })

    UIkit.tab('#tab-proxy').show(1)
  }

  handleClickHistoryTab() {
    analytics.track('click-sidebar-history', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      position: 'tab',
    })
  }

  handleClickCode() {
    analytics.track('click-sidebar-code', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      position: 'sidebar',
    })
    this.timeoutForRepull = setTimeout(() => {
      const { editor } = ((window.aceEditorReference || {}).current || {})
      const valueEditor = editor ? editor.getValue() : ''
      if (!this.props.firstTimePull || valueEditor.trim() === '') {
        this.props.rePullCode()
      }
    }, 500)
    // const editor = ace.edit('editor-sidebar')
    // editor.setValue(editor.getSession().getValue())
    // editor.clearSelection()
    this.props.onReplSetDefaultEngine()
    UIkit.tab('#tab-proxy').show(this.props.contentType === 'native' ? 0 : 2)
    // this.props.onReplOnViewError()
    this.setState({ editorIsVisible: true })
  }

  handleClickCodeOutput() {
    analytics.track('click-sidebar-code-output', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      position: 'sidebar',
    })
    UIkit.tab('#tab-proxy').show(this.props.contentType === 'native' ? 1 : 3)
    this.setState({ viewedCodeOutput: true })
  }

  handleClickPatches() {
    this.setState({ viewedPatches: true })

    analytics.track('click-sidebar-code', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      position: 'sidebar',
    })

    UIkit.tab('#tab-proxy').show(this.props.contentType === 'native' ? 2 : 4)
    this.props.onReplOnViewError()
    // this.setState({ editorIsVisible: true })
  }

  handleClickCodeTab() {
    analytics.track('click-sidebar-code', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      position: 'tab',
    })
    this.props.onReplSetDefaultEngine()
    this.setState({ editorIsVisible: true })
  }

  handleClickCodeOutputTab() {
    analytics.track('click-sidebar-code-output', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      position: 'tab',
    })
  }

  handleClickPatchHistoryTab() {
    analytics.track('click-sidebar-code', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      position: 'tab',
    })
  }

  handleOnPatch() {
    if (this.props.onPatch !== undefined) {
      this.props.onPatch()
    }
  }

  handleReplSetEngine(engine) {
    this.props.onReplSetEngine(engine)
  }

  render() {
    return (
      <>
        <div
          className="uk-margin-remove uk-padding-remove uk-background-secondary uk-animation-slide-right uk-animation-fast"
          style={{
            width: 80,
            float: 'right',
            height: 'calc(100vh - 80px)',
            display: (this.props.visible ? null : 'none'),
          }}
        >
          <div
            className="uk-offcanvas-content uk-animation-slide-right"
            style={{
              height: 'calc(100% - 30px)',
            }}
          >
            {(this.props.contentType !== 'native') && (
              <div>
                <div className="uk-text-center uk-margin-top" id="proxy-request-button">
                  <Icon
                    ratio={1.4}
                    style={{ cursor: 'pointer' }}
                    className="uk-icon-button uk-background-secondary uk-light"
                    type="button"
                    data-test-id="proxy-sidebar-btn"
                    name="dvd"
                    onClick={this.handleClickProxy}
                  />
                  <br />
                  <button
                    className="uk-button uk-button-text uk-light"
                    style={{ fontSize: 12 }}
                    data-uk-toggle="target: #offcanvas-proxy"
                    onClick={this.handleClickProxy}
                    type="button"
                  >
                    PROXY
                  </button>
                </div>
                <div className="uk-text-center uk-margin-top" id="proxy-history-button">
                  <Icon
                    ratio={1.4}
                    style={{ cursor: 'pointer' }}
                    data-test-id="sidebar-proxy-history-btn"
                    className="uk-icon-button uk-background-secondary uk-light"
                    type="button"
                    name="global"
                    data-uk-toggle="target: #offcanvas-proxy"
                    onClick={this.handleClickHistory}
                  />
                  <br />
                  <button
                    className="uk-button uk-button-text uk-light"
                    style={{ fontSize: 12 }}
                    data-uk-toggle="target: #offcanvas-proxy"
                    onClick={this.handleClickHistory}
                    type="button"
                  >
                    HISTORY
                  </button>
                </div>
              </div>
            )}
            {(this.props.engines.length > 0 && this.props.hideCodeButton === false) && (
              <div className="uk-text-center uk-margin-top" id="proxy-code-div">
                {(this.props.compiling) && (
                  <button
                    className="uk-background-secondary uk-light"
                    data-uk-spinner=""
                    data-uk-toggle="target: #offcanvas-proxy"
                    onClick={this.handleClickCode}
                    type="button"
                    data-test-id="proxy-code-button-loader"
                  />
                )}
                <Icon
                  ratio={1.4}
                  className="uk-icon-button uk-background-secondary uk-light"
                  type="button"
                  name="code"
                  data-uk-toggle="target: #offcanvas-proxy"
                  onClick={this.handleClickCode}
                  id="proxy-code-button"
                  data-test-id="proxy-code-button"
                  style={{ display: (this.props.compiling) ? ('none') : (''), cursor: 'pointer' }}
                />
                <br />
                <button
                  className="uk-button uk-button-text uk-light"
                  style={{ fontSize: 12 }}
                  data-uk-toggle="target: #offcanvas-proxy"
                  onClick={this.handleClickCode}
                  type="button"
                >
                  CODE
                </button>
              </div>
            )}

            {(this.props.engines.length > 0 && this.props.hideCodeButton === false) && (
              <div className="uk-text-center uk-margin-top" id="proxy-code-output-div">
                <Icon
                  ratio={1.4}
                  style={{ cursor: 'pointer' }}
                  className="uk-icon-button uk-background-secondary uk-light"
                  type="button"
                  data-test-id="sidebar-output-error-btn"
                  name="file-list-2"
                  data-uk-toggle="target: #offcanvas-proxy"
                  onClick={this.handleClickCodeOutput}
                  id="proxy-code-output-button"
                />
                <br />
                <button
                  className="uk-button uk-button-text uk-light"
                  data-uk-toggle="target: #offcanvas-proxy"
                  onClick={this.handleClickCodeOutput}
                  style={{ fontSize: 12 }}
                  type="button"
                >
                  OUTPUT & ERRORS
                </button>
              </div>
            )}

            {(this.props.hasTest && this.props.engines.length > 0 && this.props.hideCodeButton === false) && (
              <div className="uk-text-center uk-margin-top" id="proxy-patches-div">
                {(
                  this.props.hasTest
                  && this.props.codeSubmissions.length > 0
                  && this.props.codeSubmissions[0].test.passed === null
                  && this.state.codeSubmissionMoreThan5min
                )
                  && (
                    <button
                      className="uk-background-secondary uk-light"
                      type="button"
                      data-test-id="sidebar-patch-loader-btn"
                      data-uk-spinner=""
                      data-uk-toggle="target: #offcanvas-proxy"
                      onClick={this.handleClickPatches}
                    />
                  )}
                <Icon
                  ratio={1.4}
                  className="uk-icon-button uk-background-secondary uk-light"
                  type="button"
                  name="git-branch"
                  data-uk-toggle="target: #offcanvas-proxy"
                  onClick={this.handleClickPatches}
                  id="proxy-patches-button"
                  data-test-id="sidebar-patch-btn"
                  style={{
                    cursor: 'pointer',
                    display: (
                      this.props.hasTest
                      && this.props.codeSubmissions.length > 0
                      && this.props.codeSubmissions[0].test.passed === null
                      && this.state.codeSubmissionMoreThan5min
                    ) ? ('none') : (''),
                  }}
                />
                <br />
                <button
                  className="uk-button uk-button-text uk-light"
                  data-uk-toggle="target: #offcanvas-proxy"
                  onClick={this.handleClickPatches}
                  style={{ fontSize: 12 }}
                  type="button"
                >
                  TESTS
                </button>

                {(this.props.showPassStatus) && (
                  <div className="uk-text-middle">
                    <a href="#">
                      <span
                        className={`uk-label uk-label-${(this.props.successfulPatch) ? ('success') : ('danger')}`}
                        data-uk-toggle="target: #offcanvas-proxy"
                        onClick={this.handleClickPatches}
                        data-test-id="patch-code-success-indicator-label"
                      >
                        {(this.props.successfulPatch) ? ('Passed') : ('Failing')}
                      </span>
                    </a>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div id="offcanvas-proxy" data-test-id="offcanvas-proxy" data-uk-offcanvas="flip: true; overlay: true">
          <div className="uk-offcanvas-bar uk-background-secondary uk-light" style={{ marginTop: this.props.isQuiz ? 0 : 80 }}>
            <Icon
              style={{ cursor: 'pointer' }}
              className="uk-icon-button"
              type="button"
              name="arrow-right-s"
              data-test-id="off-canvas-close"
              onClick={() => UIkit.offcanvas('#offcanvas-proxy').hide()}
            />
            <ul data-uk-tab="active: 0" id="tab-proxy">
              {(this.props.contentType !== 'native') && (
                <li data-test-id="lesson-side-bar-proxy-tab">
                  <a href="#" onClick={this.handleClickProxyTab}>Proxy</a>
                </li>
              )}
              {(this.props.contentType !== 'native') && (
                <li>
                  <a data-test-id="lesson-side-bar-history-tab" href="#" onClick={this.handleClickHistoryTab}>
                    History
                   <span className="uk-badge uk-margin-small-left uk-padding-remove-vertical uk-padding-small">{this.props.requestCount}</span>
                  </a>
                </li>
              )}
              {(this.props.engines.length > 0 && this.props.hideCodeButton === false) && (
                <li>
                  <a href="#" onClick={this.handleClickCodeTab}>Code Editor</a>
                </li>
              )}
              {(this.props.engines.length > 0 && this.props.hideCodeButton === false) && (
                <li>
                  <a href="#" onClick={this.handleClickCodeOutputTab}>Code Output & Errors</a>
                </li>
              )}
              {(this.props.hasTest && this.props.engines.length > 0 && this.props.hideCodeButton === false) && (
                <li data-test-id="lesson-side-bar-patch-history-tab">
                  <a href="#" onClick={this.handleClickPatchHistoryTab}>Test Status</a>
                </li>
              )}
            </ul>
            <ul className="uk-switcher uk-margin">
              {(this.props.contentType !== 'native') && (
                <li>
                  <ProxyEditor
                    handleClickResume={this.props.onClickResume}
                    intercept={this.props.intercept}
                    pendingRequest={this.props.pendingRequest}
                  />
                </li>
              )}
              {(this.props.contentType !== 'native') && (
                <li>
                  <ProxyHistory requests={this.props.requests} />
                </li>
              )}
              {(this.props.engines.length > 0 && this.props.hideCodeButton === false) && (
                <li>
                  <CodeEditor
                    isNative={this.props.contentType === 'native'}
                    rePullCode={this.props.rePullCode}
                    contentUUID={this.props.match.params.id}
                    onRef={(ref) => { this.codeEditorComponent = ref }}
                    ecsTaskDefinition={this.props.ecsTaskDefinition}
                    editorId="editor-sidebar"
                    data-test-id="editor-sidebar"
                    engines={this.props.engines}
                    hasTest={this.props.hasTest}
                    onPatch={this.handleOnPatch}
                    onReplSetEngine={this.handleReplSetEngine}
                    socket={this.props.socket}
                    visible={this.state.editorIsVisible}
                  />
                </li>
              )}
              {(this.props.engines.length > 0 && this.props.hideCodeButton === false) && (
                <li>
                  <CodeOutput output={this.state.output} />
                </li>
              )}
              {(this.props.hasTest && this.props.engines.length > 0 && this.props.hideCodeButton === false) && (
                <li>
                  <PatchHistory
                    contentType={this.props.contentType}
                    codeSubmissions={this.props.codeSubmissions}
                    hasTest={this.props.hasTest}
                  />
                </li>
              )}
            </ul>

          </div>
        </div>
      </>
    )
  }
}

LessonSidebar.propTypes = propTypes
LessonSidebar.defaultProps = defaultProps

export default withRouter(LessonSidebar)
